import { z } from 'zod';
// One GPS reading — a position a device reported: the check-in ceremony's
// fact, the nearby read's centre. Optional as a whole wherever it rides (a
// person may decline to share); `accuracy_m` is the phone's radius, through
// the channel, when given — a DECIMAL as providers send it (Telegram's
// `horizontal_accuracy` is a float); the server rounds to the metre at the
// ceremony, never the channel. Shared by every module that takes a position —
// declared once, here.
export const FixSchema = z
    .object({
    lat: z.number().min(-90).max(90),
    lng: z.number().min(-180).max(180),
    accuracy_m: z.number().nonnegative().max(100_000).optional(),
})
    .strict();
// ── the list fragment — distance as a list convention (ADR-071) ─────────────
// A REFERENCE POINT on a list read: the caller names a point (a device fix, a
// site's registered location, a depot) and the rows come back with their
// straight-line distance from it (`distance_m`), optionally bounded to a radius
// and sorted nearest first. It is a query parameter and nothing more — never
// the caller's position (a dispatcher sorting "near Site X" passes the site's
// coordinates), and reads never write. Any site-anchored list adopts it with
// `.extend(GeoListQueryShape)` + `'distance'` among its sort keys; the service
// measures with core/geo's one ruler. On the wire `near` is `lat,lng` — WGS84
// decimal degrees, the platform's one coordinate format — so it travels in a
// URL like every other view-state param.
const DECIMAL_DEGREES = /^[+-]?\d+(\.\d+)?$/;
export const LatLngParamSchema = z.preprocess((v) => {
    if (v === '')
        return undefined; // a cleared URL key reads as absent, like every other list param
    if (typeof v !== 'string')
        return v;
    const parts = v.split(',').map((s) => s.trim());
    // Decimal degrees only (no hex / exponent literals); malformed → handed on
    // as-is so the object schema refuses it (a 400).
    if (parts.length !== 2 || !parts.every((s) => DECIMAL_DEGREES.test(s)))
        return v;
    return { lat: Number(parts[0]), lng: Number(parts[1]) };
}, z.object({ lat: z.number().min(-90).max(90), lng: z.number().min(-180).max(180) }).strict().optional());
export const GeoListQueryShape = {
    near: LatLngParamSchema,
    /** Bounds the rows to this straight-line distance (metres) from `near` —
     *  the exact circle, never the box. Requires `near`. */
    radius_m: z.preprocess((v) => (v === '' ? undefined : v), z.coerce.number().int().positive().max(1_000_000).optional()),
};
